export default __webpack_public_path__ + "static/media/neev-logo.982fc7d2.svg";